module.exports = __webpack_public_path__ + "static/img/gold 3.69fe15b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/valorant/gold 3.png
// module id = WWkF
// module chunks = 35